import React, { useState, useEffect, useContext } from 'react';
import {
  Box,
  Typography,
  Button,
  Divider,
  Grid,
  Chip,
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
  Link,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  Stack,
} from '@mui/material';
import { poppins400, poppins500 } from 'theme/common.style';
import AiBannerStar from 'assets/svg/AiBannerStar.svg';
import { Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTheme } from '@emotion/react';
import { postApiCall } from 'api/apiService';
import { CANCEL_FLOW, MOVETO_SETTLEMENT } from 'constant/app.config';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { SettlementCompletePopup } from './SettlementSuccessPopup';
import ViewContractDialog from './ViewContract';
import CircularProgress from '@mui/material/CircularProgress';
import Loading from 'assets/images/loading.png';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const SettlementConfirm = ({
  openSettleConfirm,
  setOpenSettleConfirm,
  price,
  winner,
  propAddress,
  depositAmount,
  propertyId,
  buyerId,
  setShowUpdateSettlement,
  setOpenUpdateSettlement,
  getListInfo,
  publishcard,
  unpublishcard,
  buyerContract,
  vendorContract,
  profileDetails,
  from,
}) => {
  const theme = useTheme();
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [openSuccess, setOpenSuccess] = useState(false);
  // to open contract pdf
  const [openContract, setOpenContract] = useState(false);
  const [contractFile, setContractFile] = useState('');
  const [pdfLoading, setPdfLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const { bannerApiTrigger } = useContext(datacontext);
  const [signedAtTime, setSignedAtTime] = useState('');
  // to open deposit warning
  const [openDepositWarning, setOpenDepositWarning] = useState(false);
  const handleCloseDepositWarning = () => {
    setOpenDepositWarning(false);
  };

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
    bannerApiTrigger();
    if (typeof publishcard === 'function') {
      publishcard();
    }

    if (typeof unpublishcard === 'function') {
      unpublishcard();
    }
    //  getListInfo()
  };
  const handleClose = () => {
    // if (from == 'dashboard' && normalizedDeposit != normalizedPrice) {
    //   setOpenSettleConfirm(false);
    //   return;
    // }
    setOpenSettleConfirm(false);
    setShowUpdateSettlement(true);
    setOpenUpdateSettlement(true);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleReminderClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = async (option) => {
    //to close the dialog and git cancelsettlement api
    const params = {
      propertyId: propertyId,
      buyerId: buyerId,
      action: 'Settlement',
      noOfMin: option,
    };
    try {
      const res = await postApiCall(CANCEL_FLOW, params);
      handleReminderClose();
      if (res.data?.status == -1) {
        Swal.fire({
          title: res?.data?.heading,
          text: res?.data?.message,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      } else {
        setOpenSettleConfirm(false);
        Swal.fire({
          title: res?.data?.heading,
          text: res?.data?.message,
          icon: 'success',
          confirmButtonText: 'Close',
        }).then(() => {
          if (typeof publishcard === 'function') {
            publishcard();
          }

          if (typeof unpublishcard === 'function') {
            unpublishcard();
          }
        });
        // getListInfo()
      }
    } catch (err) {
      console.error(err);
      handleReminderClose();
    }
  };
  const normalizeAmount = (value) =>
    Number(String(value).replace(/[^0-9.]/g, ''));

  const normalizedDeposit = normalizeAmount(depositAmount);
  const normalizedPrice = normalizeAmount(price);

  const handleSettlement = async () => {
    if (from == 'dashboard' && normalizedDeposit != normalizedPrice) {
      setOpenDepositWarning(true);
      return;
    }
    setLoading(true);
    const params = {
      propertyId: propertyId,
      buyerId: buyerId,
      isSettlement: 1,
    };
    try {
      const res = await postApiCall(MOVETO_SETTLEMENT, params);
      if (res.data?.status !== 1) {
        Swal.fire({
          title: res?.data?.heading || 'Error',
          text: res?.data?.message || 'Something went wrong',
          icon: 'error',
          confirmButtonText: 'Close',
        });
        setLoading(false);
      } else {
        setLoading(false);

        setOpenSuccess(true);
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
    setOpenSettleConfirm(false);
    setLoading(false);
  };

  const Pendingwarning = () => {
    return (
      <svg
        width="38"
        height="36"
        viewBox="0 0 38 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="37.5797"
          height="36"
          rx="18"
          fill="#F39800"
          fill-opacity="0.1"
        />
        <path
          d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
          fill="#F39800"
        />
      </svg>
    );
  };

  const Editbox = () => {
    return (
      <svg
        width="75"
        height="26"
        viewBox="0 0 75 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.75"
          y="0.75"
          width="73.5"
          height="24.5"
          rx="4.25"
          stroke="#007AFF"
          stroke-width="1.5"
        />
        <path
          d="M38.304 8.684V9.548H34.992V12.38H37.944V13.232H34.992V16.136H38.304V17H33.9V8.684H38.304ZM44.4346 15.5C44.8746 15.052 45.0946 14.456 45.0946 13.712C45.0946 12.968 44.8746 12.372 44.4346 11.924C44.0026 11.476 43.4786 11.252 42.8626 11.252C42.2546 11.252 41.7306 11.468 41.2906 11.9C40.8586 12.332 40.6426 12.92 40.6426 13.664C40.6426 14.408 40.8626 15.012 41.3026 15.476C41.7426 15.94 42.2666 16.172 42.8746 16.172C43.4826 16.172 44.0026 15.948 44.4346 15.5ZM42.6706 17.108C41.7746 17.108 41.0266 16.788 40.4266 16.148C39.8266 15.5 39.5266 14.676 39.5266 13.676C39.5266 12.668 39.8226 11.856 40.4146 11.24C41.0146 10.616 41.7666 10.304 42.6706 10.304C43.2306 10.304 43.7186 10.436 44.1346 10.7C44.5586 10.964 44.8786 11.308 45.0946 11.732V8.12H46.1986V17H45.0946V15.656C44.8786 16.088 44.5586 16.44 44.1346 16.712C43.7186 16.976 43.2306 17.108 42.6706 17.108ZM49.0777 9.14C48.9337 9.284 48.7577 9.356 48.5497 9.356C48.3417 9.356 48.1657 9.284 48.0217 9.14C47.8857 8.996 47.8177 8.82 47.8177 8.612C47.8177 8.404 47.8897 8.228 48.0337 8.084C48.1777 7.94 48.3497 7.868 48.5497 7.868C48.7577 7.868 48.9337 7.94 49.0777 8.084C49.2217 8.228 49.2937 8.404 49.2937 8.612C49.2937 8.82 49.2217 8.996 49.0777 9.14ZM47.9977 17V10.412H49.0897V17H47.9977ZM53.0522 16.112H53.9522V17H52.8482C51.7042 17 51.1322 16.436 51.1322 15.308V11.3H50.2802V10.412H51.1322V8.78H52.2362V10.412H53.9402V11.3H52.2362V15.308C52.2362 15.604 52.2962 15.812 52.4162 15.932C52.5362 16.052 52.7482 16.112 53.0522 16.112Z"
          fill="#007AFF"
        />
        <g clip-path="url(#clip0_37791_90812)">
          <path
            d="M9.5 19.5003H13L22.1875 10.3128C22.6516 9.84864 22.9124 9.21914 22.9124 8.56276C22.9124 7.90639 22.6516 7.27689 22.1875 6.81276C21.7234 6.34864 21.0939 6.08789 20.4375 6.08789C19.7811 6.08789 19.1516 6.34864 18.6875 6.81276L9.5 16.0003V19.5003Z"
            stroke="#529AEE"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.8125 6.6875L22.3125 10.1875"
            stroke="#529AEE"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_37791_90812">
            <rect
              width="21"
              height="21"
              fill="white"
              transform="translate(6 1)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };

  const Sign = () => {
    return (
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_37216_88626)">
          <path
            d="M2.375 13.4583C5.01363 10.8197 6.33333 8.70833 6.33333 7.125C6.33333 4.75 5.54167 4.75 4.75 4.75C3.95833 4.75 3.14133 5.60896 3.16667 7.125C3.19358 8.74633 4.47925 10.986 5.14583 11.875C6.33333 13.4583 7.125 13.8542 7.91667 12.6667L9.5 10.2917C9.76363 12.403 10.5553 13.4583 11.875 13.4583C12.2946 13.4583 13.9642 11.875 14.25 11.875C14.6593 11.875 15.451 12.403 16.625 13.4583"
            stroke="#62CB4C"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_37216_88626">
            <rect width="19" height="19" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };
  const propertyDetails = {
    Property: '56 Owen Street, Bondi Beach NSW 2026',
    Price: '$2,350,000',
    SettlementDays: '42 days after the exchanged contract date',
    Buyer: 'Kiel Glass',
    DepositAmount: '$235,000',
  };

  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);

  const history = useHistory();
  const handleViewDepositDetails = () => {
    if (from === 'dashboard') {
      sessionStorage.setItem(
        'navAction',
        JSON.stringify({
          type: 'deposit',
          winningBuyerId: profileDetails?.isWinnerId,
          depositFlow: profileDetails?.isWinnerRequestedAmount === null,
        })
      );

      history.push(`/dashboard/view-dashboard/${propertyId}`);
    }
  };

  return (
    <>
      <Dialog
        open={openSettleConfirm}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleClose();
          }
        }}
        fullWidth
        maxWidth="md"
        // sx={{
        //   '&.MuiDialog-root': {
        //     pointerEvents: 'none',
        //     left: '80px',
        //     right: '-80px',
        //     top: '80px',
        //     bottom: '-80px',
        //   },
        //   '& .MuiDialog-container': {
        //     pointerEvents: 'auto',
        //     justifyContent: 'flex-start',
        //   },
        //   '& .MuiPaper-root': {
        //     pointerEvents: 'auto',
        //   },
        //   '& .MuiBackdrop-root': {
        //     left: '80px',
        //     right: '-80px',
        //     top: '80px',
        //     bottom: '-80px',
        //   },
        // }}
        PaperProps={{
          sx: {
            maxWidth: '720px',
            padding: 2,
            width: matches450 ? '100%' : '720px',
            maxWidth: matches450 ? '100%' : 'unset',
            padding: 2,
            // m: matches450 ? 1 : 'auto',
          },
        }}
      >
        <DialogTitle sx={{ p: 2, pl: 3, pr: 3, fontWeight: 600 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              sx={{
                ...poppins400,
                fontSize: '14px',
                color: '#666666',
              }}
            >
              {propAddress}
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ pt: 0, px: 3, pb: 2 }}>
          <Box display="flex" alignItems="center" gap={1}>
            <Pendingwarning />
            <Typography
              sx={{ ...poppins500, color: '#000000', fontSize: '24px' }}
            >
              Settlement Status Confirmation
            </Typography>
          </Box>
          <Typography
            sx={{
              ...poppins400,
              fontSize: '16px',
              color: '#666666',
            }}
            mt={3}
            mb={2}
          >
            Please confirm the property transaction can now be marked as
            SETTLED. The listing will be moved to the Archived section.
          </Typography>
          <Divider sx={{ my: 2, mx: -3 }} />
          <Typography
            sx={{
              ...poppins400,
              fontSize: '24px',
              color: '#000000',
            }}
          >
            Summary
          </Typography>

          <Grid container direction="column" spacing={2} pl={1}>
            {/* Property */}
            <Grid item container mt={3} alignItems="flex-start">
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  mr: 1,
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Property:
                </Typography>
              </Grid>
              <Grid item xs zeroMinWidth ml={6}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#000000',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                  }}
                >
                  {propAddress}
                </Typography>
              </Grid>
            </Grid>

            {/* Price */}
            <Grid item container mt={3}>
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  mr: 1,
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Price:
                </Typography>
              </Grid>
              <Grid item xs zeroMinWidth ml={6}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#000000',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                  }}
                >
                  {price}
                </Typography>
              </Grid>
            </Grid>

            {/* Buyer */}
            <Grid item container mt={3}>
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  mr: 1,
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Buyer:
                </Typography>
              </Grid>
              <Grid item xs zeroMinWidth ml={6}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#000000',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                  }}
                >
                  {winner}
                </Typography>
              </Grid>
            </Grid>

            {/* Buyer Contract */}
            <Grid item container mt={3} mb={2} alignItems="center">
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  mr: 1,
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Buyer Contract:
                </Typography>
              </Grid>
              <Grid item xs zeroMinWidth ml={6}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#000000',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Stack
                    direction={'row'}
                    alignItems="center"
                    spacing={1}
                    sx={{
                      borderRadius: '15px',
                      backgroundColor: '#CEFECE',
                      padding: '4px 8px',
                      minHeight: '32px',
                      width: 'fit-content',
                    }}
                  >
                    <Sign sx={{ color: '#3FBA20' }} />

                    <Typography
                      sx={{
                        fontSize: matches450 ? '14px' : '16px',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        color: '#3FBA20',
                      }}
                    >
                      Signed
                    </Typography>
                  </Stack>
                  <Link
                    href="#"
                    underline="none"
                    sx={{
                      color: '#007AFF',
                      ...poppins400,
                      fontSize: '16px',
                      ml: 0.5,
                      '&:hover': {
                        textDecoration: 'none',
                        color: '#007AFF',
                      },
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      setContractFile(buyerContract);
                      setSignedAtTime(
                        profileDetails?.PropertyDetails
                          ?.isWinnerContractSignedAt ||
                          profileDetails?.isWinnerContractSignedAt
                      );
                      setOpenContract(true);
                    }}
                  >
                    View
                  </Link>
                </Typography>
              </Grid>
            </Grid>

            {/* Vendor Contract */}
            <Grid item container>
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  mr: 1,
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Vendor Contract:
                </Typography>
              </Grid>
              <Grid item xs zeroMinWidth ml={6}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#000000',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Stack
                    direction={'row'}
                    alignItems="center"
                    spacing={1}
                    sx={{
                      borderRadius: '15px',
                      backgroundColor: '#CEFECE',
                      padding: '4px 8px',
                      minHeight: '32px',
                      width: 'fit-content',
                    }}
                  >
                    <Sign sx={{ color: '#3FBA20' }} />

                    <Typography
                      sx={{
                        fontSize: matches450 ? '14px' : '16px',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        color: '#3FBA20',
                      }}
                    >
                      Signed
                    </Typography>
                  </Stack>

                  <Link
                    href="#"
                    underline="none"
                    sx={{
                      color: '#007AFF',
                      ...poppins400,
                      fontSize: '16px',
                      ml: 0.5,
                      '&:hover': {
                        textDecoration: 'none',
                        color: '#007AFF',
                      },
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      setContractFile(vendorContract);
                      setSignedAtTime(
                        profileDetails?.PropertyDetails
                          ?.vendorContractSignedAt ||
                          profileDetails?.vendorContractSignedAt
                      );
                      setOpenContract(true);
                    }}
                  >
                    View
                  </Link>
                </Typography>
              </Grid>
            </Grid>

            {/* Deposit Amount */}
            <Grid item container alignItems="center" mt={3}>
              <Grid
                item
                sx={{
                  whiteSpace: matches450 ? 'normal' : 'nowrap',
                  mr: 1,
                  width: matches450 ? 70 : 130,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: '#666666',
                  }}
                >
                  Deposit Amount:
                </Typography>
              </Grid>
              <Grid item xs zeroMinWidth ml={6}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '16px',
                      color: '#000000',
                      wordBreak: 'break-word',
                      overflowWrap: 'break-word',
                    }}
                  >
                    {depositAmount}
                  </Typography>
                  <Chip
                    label={
                      normalizedDeposit != normalizedPrice
                        ? 'Partially Paid'
                        : 'Paid'
                    }
                    size="small"
                    sx={{
                      ...poppins400,
                      fontSize: '13px',
                      color:
                        normalizedDeposit != normalizedPrice
                          ? '#3854B7'
                          : 'white',
                      backgroundColor:
                        normalizedDeposit != normalizedPrice
                          ? '#DCEAFE'
                          : '#08A742',
                      height: 24,
                      width: normalizedDeposit != normalizedPrice ? 110 : 70,
                      ml: 1,
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
          {/* Bottom Note */}
          <Box
            marginTop={8}
            marginBottom={4}
            sx={{
              maxWidth: '620px',
              pt: 1.5,
              pb: 1.5,
              borderRadius: 2,
              border: '1px solid #965CF0',
            }}
            display={'flex'}
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
          >
            <img
              src={AiBannerStar}
              alt="Star"
              style={{
                height: '35px',
                width: '35px',
                flexShrink: 0,
              }}
            />
            <Typography
              sx={{
                ...poppins400,
                fontSize: '16px',
                color: '#666666',
              }}
            >
              Archived Properties can be found within your Dashboard. <br />
              Tip: You can use the search bar.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            pb: 7,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 1.5,
            alignItems: 'stretch',
          }}
        >
          <Button
            variant="outlined"
            sx={{
              ...poppins400,
              fontSize: '14px',
              bgcolor: '#fff',
              borderRadius: '8px',
              borderColor: '#1123471A',
              textTransform: 'none',
              color: '#666666',
              '&:hover': {
                bgcolor: '#fff',
                borderColor: '#1123471A',
              },
            }}
            onClick={handleClose}
          >
            Cancel
          </Button>

          <Button
            onClick={handleClick}
            endIcon={<ArrowDropDownIcon />}
            // sx={{ textTransform: 'none', mx: 1 }}
            variant="outlined"
            disable={loading}
            sx={{
              ...poppins400,
              fontSize: '14px',
              bgcolor: '#fff',
              borderRadius: '8px',
              borderColor: '#1123471A',
              textTransform: 'none',
              color: '#666666',
              '&:hover': {
                bgcolor: '#fff',
                borderColor: '#1123471A',
              },
            }}
          >
            Remind me
          </Button>
          <Menu anchorEl={anchorEl} open={open} onClose={handleReminderClose}>
            <MenuItem onClick={() => handleOptionClick('30')}>
              after 30 minutes
            </MenuItem>
            <MenuItem onClick={() => handleOptionClick('60')}>
              after 1 hour
            </MenuItem>
            <MenuItem onClick={() => handleOptionClick('180')}>
              after 3 hours
            </MenuItem>
            <MenuItem onClick={() => handleOptionClick('360')}>
              after 6 hours
            </MenuItem>
            <MenuItem onClick={() => handleOptionClick('720')}>
              after 12 hours
            </MenuItem>
          </Menu>
          <Button
            variant="contained"
            sx={{
              ...poppins400,
              fontSize: '14px',
              bgcolor: '#4CA4D6',
              borderRadius: '8px',
              textTransform: 'none',
              '&:hover': {
                bgcolor: '#3293d0',
              },
            }}
            onClick={handleSettlement}
          >
            {' '}
            Confirm Settled
          </Button>
          {loading && (
            <img
              alt="Logo"
              src={Loading}
              className="loaderImage"
              style={{ height: '40px', width: '40px' }}
            />
          )}
        </DialogActions>
      </Dialog>

      <SettlementCompletePopup
        open={openSuccess}
        onClose={handleCloseSuccess}
        address={propAddress}
      />

      {/* to open contract pdf */}
      <ViewContractDialog
        open={openContract}
        onClose={() => setOpenContract(false)}
        contractFile={contractFile}
        signedAt={signedAtTime}
        address={propAddress}
        pdfLoading={pdfLoading}
        setPdfLoading={setPdfLoading}
      />
      {/* warning message for incomplete depositpayment */}
      <Dialog
        open={openDepositWarning}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return; // prevent close
          }
          handleCloseDepositWarning();
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            ...poppins500,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            color: '#000000',
            fontSize: '24px',
          }}
        >
          <Pendingwarning />
          Settlement Payment Pending
        </DialogTitle>
        <DialogContent>
          {/* <Typography sx={{ mt: 1 }}> */}
          <Typography
            sx={{
              ...poppins400,
              fontSize: '16px',
              color: '#666666',
            }}
            mt={1}
            mb={2}
          >
            Total offer amount has not been paid completely.
          </Typography>
          <Typography
            sx={{
              ...poppins400,
              fontSize: '16px',
              color: '#666666',
            }}
            mt={1}
            mb={2}
          >
            {' '}
            Please complete the deposit to proceed further.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            variant="outlined"
            sx={{
              ...poppins400,
              fontSize: '14px',
              bgcolor: '#fff',
              borderRadius: '8px',
              borderColor: '#1123471A',
              textTransform: 'none',
              color: '#666666',
              '&:hover': {
                bgcolor: '#fff',
                borderColor: '#1123471A',
              },
            }}
            onClick={() => {
              setOpenSettleConfirm(false);
              setOpenDepositWarning(false);
            }}
          >
            Close
          </Button>
          {/* view deposit details */}
          <Button
            variant="contained"
            sx={{
              ...poppins400,
              fontSize: '14px',
              bgcolor: '#4CA4D6',
              borderRadius: '8px',
              textTransform: 'none',
              '&:hover': {
                bgcolor: '#3293d0',
              },
            }}
            onClick={handleViewDepositDetails}
          >
            {' '}
            View Deposit Details
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SettlementConfirm;
